import React from 'react'
import { TableHeader } from '../../../commons';
import { JOBS_TABLE_HEADER } from '../../../../constant/tableHeadersConstants/Jobs/JobsTableHeader';
import JobsTableData from './JobsTableData';

type AppProps = {
    history: any;
    data: any;
    isEditJobsPresent?:boolean;
    handleEditJobsDetails:(id:string)=>void;
}

const JobsTable = ({
      history,
      data,
      isEditJobsPresent,
      handleEditJobsDetails
     }: AppProps) => {

    return (
        <div className='jobsType table-responsive'>
            <table className="table thead-light table-bordered">
                <thead className='text-start sticky-table-header'>
                    <TableHeader
                        tableHeader={JOBS_TABLE_HEADER} extraHeader
                    />
                </thead>
                <tbody>
                    <JobsTableData
                        history={history}
                        data={data}
                        tableHeader={JOBS_TABLE_HEADER}
                        handleEditJobsDetails={handleEditJobsDetails}
                        isEditJobsPresent={isEditJobsPresent}
                    />
                </tbody>
            </table>
        </div>
    )
}

export default JobsTable